<div class="dashboard-container white-background">
  <div class="header-section">
    <app-header></app-header>
  </div>

  <div class="content-wrapper">
    <div class="layout-container">
      <div>
        <div class="left-side-panel">
          <router-outlet name="leftSidePanel"></router-outlet>
        </div>
      </div>
      <div class="main-panel" [class.expanded]="dashboardHelper.leftPanelCollapsed | async" [class.shrinked]="!(dashboardHelper.leftPanelCollapsed | async)">
        <!-- graphPanel -->

        @if (dashboardHelper.showGraphPanel | async) {
        <app-shared-header></app-shared-header>
        }
        <div class="main-view-container" [class.with-graph-panel]="dashboardHelper.showGraphPanel | async" [class.without-graph-panel]="!(dashboardHelper.showGraphPanel | async)">
          <div
            class="main-router-parent"
            [class.expand]="!(dashboardHelper.leftPanelCollapsed | async)"
            [class.shrink]="dashboardHelper.leftPanelCollapsed | async"
            [class.shrink-full]="dashboardHelper.isRightPanelExpanded | async">
            @if (isViewLoading) {
            <div class="main-panel-loading-overlay">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
            }
            <router-outlet name="mainPanel"></router-outlet>
          </div>

          @if (dashboardHelper.$showRightPanel | async) {
          <div
            class="right-panel"
            [class.show]="dashboardHelper.$showRightPanel | async"
            [class.expanded]="dashboardHelper.isRightPanelExpanded | async"
            [class.hide]="!(dashboardHelper.$showRightPanel | async)"
            [style.width.px]="rightPanelWidth"
            [style.minWidth.px]="rightPanelMinWidth"
            [style.maxWidth.px]="rightPanelMaxWidth">
            <div class="right-panel-resize-handle" (mousedown)="onRightPanelResizeStart($event)"></div>
            <app-panel-edge-toggle></app-panel-edge-toggle>
            <div class="right-panel-body">
              @if ((dashboardHelper.sharedRightPanelHeaderVisible | async) && ((isBlueprintEditorActive$ | async) || !(dashboardHelper.isRightPanelExpanded | async))) {
              <app-shared-right-panel-header></app-shared-right-panel-header>
              }
              <router-outlet name="rightPanel"></router-outlet>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="tab-panel" [class.with-settings-tree]="dashboardHelper.settingsTabActive | async">
        @if (dashboardHelper.settingsTabActive | async) {
        <div class="settings-tree-panel">
          <p-tree
            [value]="(dashboardHelper.settingsTreeNodes | async) ?? []"
            selectionMode="single"
            [(selection)]="selectedSettingsNode"
            (onNodeSelect)="onSettingsNodeSelect($event.node)">
            <ng-template let-node pTemplate="default">
              <span>{{ node.label }}</span>
            </ng-template>
          </p-tree>
        </div>
        }
        <div class="settings-content-panel">
          <router-outlet name="tabPanel"></router-outlet>
        </div>
      </div>
    </div>
    <app-chat-window></app-chat-window>
  </div>
  @if (isServerProcessing) {
  <div class="divSpinner">
    <mat-spinner></mat-spinner>
  </div>
  }
</div>
